var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = { class: "constructor-set-box__title" };
var _hoisted_2 = { class: "constructor-set-box__content" };
var _hoisted_3 = { class: "constructor-set-box__title" };
var _hoisted_4 = { class: "constructor-set-box__summary" };
var _hoisted_5 = { class: "constructor-set-box__button" };
var _hoisted_6 = ["disabled"];
var _hoisted_7 = ["disabled"];
var _hoisted_8 = {
    key: 1,
    class: "constructor-set-box"
};
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import Sprite from "../../components/Sprite.vue";
import Price from "../../components/Price.vue";
import UserSetModal from "../user_sets/UserSetModal.vue";
import EventBus from "../../events/EventBus";
import { handleAddToCartButtonClick } from "../../components/product/add_to_cart";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserSetConstructorApp',
    props: {
        set: { type: Object, required: true },
        mode: { type: String, default: 'constructor' },
        authorized: { type: Boolean, default: false },
        status: { type: String, default: 'create' },
        openModal: { type: Boolean, default: false },
    },
    setup: function (__props) {
        var _a;
        var props = __props;
        var modal = ref();
        // Локальное состояние сета
        var setContent = ref(__spreadArray([], __read(props.set.content), false));
        var setName = ref(props.set.name);
        var setUuid = ref((_a = props.set.uuid) !== null && _a !== void 0 ? _a : null);
        var currentStatus = ref(props.status);
        var saving = ref(false);
        // Синхронизация данных сета
        function applySetData(set) {
            var _a;
            if (set.content) {
                setContent.value = __spreadArray([], __read(set.content), false);
            }
            if (set.name !== undefined) {
                setName.value = set.name;
            }
            if (set.uuid !== undefined) {
                setUuid.value = (_a = set.uuid) !== null && _a !== void 0 ? _a : null;
            }
        }
        watch(function () { return props.set; }, function (newSet) { return applySetData(newSet); });
        var sharedSet = computed(function () {
            var _a;
            return (__assign(__assign({}, props.set), { uuid: (_a = setUuid.value) !== null && _a !== void 0 ? _a : props.set.uuid, name: setName.value, content: setContent.value }));
        });
        var count = computed(function () { return setContent.value.length; });
        var maxItems = computed(function () { return props.set.maxItems; });
        var setFilled = computed(function () { return count.value === maxItems.value; });
        var currentPrice = computed(function () {
            return setContent.value.reduce(function (sum, item) { return sum + item.price; }, 0);
        });
        var canBuy = computed(function () { return setContent.value.every(function (item) { return item.available; }); });
        function addToCart() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!setFilled.value || !canBuy.value) {
                                return [2 /*return*/];
                            }
                            saving.value = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, handleAddToCartButtonClick({
                                    type: props.mode === 'constructor' ? 'draft' : 'user_set',
                                    id: setUuid.value,
                                })];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            saving.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        var handleUpdateEvent = function (newData) {
            if (newData === null || newData === void 0 ? void 0 : newData.set) {
                applySetData(newData.set);
            }
            if (newData === null || newData === void 0 ? void 0 : newData.status) {
                currentStatus.value = newData.status;
            }
        };
        function showModal() {
            var _a;
            if (count.value > 0) {
                (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
            }
        }
        onMounted(function () {
            EventBus.on('set:update', handleUpdateEvent);
        });
        onUnmounted(function () {
            EventBus.off('set:update', handleUpdateEvent);
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (currentStatus.value === 'create' || currentStatus.value === 'edit')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["constructor-set-box", { 'constructor-set-box--filled': setFilled.value }])
                    }, [
                        (currentStatus.value === 'create')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(setFilled.value ? 'Новый сет собран' : 'Собираем новый сет'), 1 /* TEXT */),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxItems.value, function (n) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: n,
                                            class: _normalizeClass(["constructor-set-box__item", { 'is-active': n <= count.value }])
                                        }, [
                                            _createVNode(Sprite, {
                                                name: "atomizer",
                                                size: 32
                                            })
                                        ], 2 /* CLASS */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
                            : (currentStatus.value === 'edit')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _cache[1] || (_cache[1] = _createTextVNode("\n        Редактируем сет", -1 /* CACHED */)),
                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                        _createElementVNode("strong", null, "«" + _toDisplayString(setName.value) + "»", 1 /* TEXT */)
                                    ]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "constructor-set-box__content" }, [
                                        _createElementVNode("img", {
                                            src: "/img/set-box.svg",
                                            width: "60",
                                            height: "44",
                                            alt: ""
                                        })
                                    ], -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("strong", null, _toDisplayString(count.value) + " из " + _toDisplayString(maxItems.value), 1 /* TEXT */),
                            _cache[5] || (_cache[5] = _createTextVNode(" на сумму\n      ", -1 /* CACHED */)),
                            _createElementVNode("strong", null, [
                                _createVNode(Price, { amount: currentPrice.value }, null, 8 /* PROPS */, ["amount"])
                            ])
                        ]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                onClick: showModal,
                                type: "button",
                                class: "btn btn--2 btn--s btn--black wide",
                                disabled: count.value === 0
                            }, _toDisplayString(count.value > 0 ? 'Состав сета' : 'Сет пуст'), 9 /* TEXT, PROPS */, _hoisted_6),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            (setFilled.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn--1 btn--s btn--black wide",
                                    style: { "margin-top": "8px" },
                                    disabled: saving.value || !canBuy.value,
                                    onClick: addToCart
                                }, _toDisplayString(saving.value ? 'Добавление...' : 'В корзину'), 9 /* TEXT, PROPS */, _hoisted_7))
                                : _createCommentVNode("v-if", true)
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _cache[10] || (_cache[10] = _createTextVNode()),
                (currentStatus.value === 'full')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, __spreadArray([], __read((_cache[9] || (_cache[9] = [
                        _createStaticVNode("<div class=\"constructor-set-box__title\">Достигнут лимит в 10 сетов</div> <div class=\"constructor-set-box__content\"><img src=\"/img/sets-carousel.svg\" width=\"248\" height=\"44\" alt=\"\"></div> <div class=\"constructor-set-box__summary\">Удалите один из сетов, чтобы добавить новый</div> <div class=\"constructor-set-box__button\"><a href=\"/profile/sets/\" class=\"btn btn--2 btn--s btn--black wide\">Мои сеты</a></div>", 7)
                    ]))), false)))
                    : _createCommentVNode("v-if", true),
                _cache[11] || (_cache[11] = _createTextVNode()),
                (currentStatus.value !== 'full')
                    ? (_openBlock(), _createBlock(UserSetModal, {
                        key: 2,
                        ref_key: "modal",
                        ref: modal,
                        set: sharedSet.value,
                        mode: __props.mode,
                        authorized: __props.authorized,
                        open: __props.openModal
                    }, null, 8 /* PROPS */, ["set", "mode", "authorized", "open"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
